import { SVGProps, Ref, forwardRef } from 'react';

export const LocationFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.977 3.714 5.47 6.93C2.448 8.226.937 8.873 1.002 9.856s1.648 1.427 4.815 2.313l4.698 1.316 1.316 4.698c.886 3.167 1.33 4.75 2.313 4.815s1.63-1.446 2.926-4.469l3.216-7.506c2.323-5.418 3.484-8.128 2.151-9.46-1.332-1.333-4.042-.172-9.46 2.15"
                fill="currentColor"
            />
        </g>
    </svg>
));
LocationFilledSize24Glyph.displayName = 'LocationFilledSize24Glyph';
